import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Grid, Typography, Button, Box, Popover, AppBar, Drawer, IconButton } from '@mui/material';
import { ArrowDropDown } from '@mui/icons-material';
import ArrowDropUp from '@mui/icons-material/ArrowDropUp';
import logo from '../images/logo.png';
import logo_black from '../images/logo-black.png';
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close'
import HouseIcon from '@mui/icons-material/House';
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import CastForEducationIcon from '@mui/icons-material/CastForEducation';
import SchoolIcon from '@mui/icons-material/School';
import InfoIcon from '@mui/icons-material/Info';

const Header1 = () => {
    const navigate = useNavigate();
    const [anchorEl, setAnchorEl] = useState(null); // For Popover
    const [drawerOpen, setDrawerOpen] = useState(false); // For Drawer

    const [scrollPosition, setScrollPosition] = useState(0);

    useEffect(() => {
        const handleScroll = () => {
            setScrollPosition(window.scrollY);
        };

        window.addEventListener("scroll", handleScroll);
        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);

    const isScrolled = scrollPosition > 50;

    // Handle Popover Open/Close
    const handlePopoverOpen = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handlePopoverClose = () => {
        setAnchorEl(null);
    };

    const toggleDrawer = (open) => () => {
        setDrawerOpen(open);
    };


    const toggleCloser = (open) => (event) => {
        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }
        setDrawerOpen(open);
    };

    // Styling for buttons
    const buttonStyle = {
        color: isScrolled ? '#fff' : '#1e293b',
        fontWeight: 500,
        fontSize: '1.1rem',
        textTransform: 'none',
        transition: 'all 0.3s ease',
        '&:hover': {
            color: isScrolled ? '#ff8a50' : '#1a237e',
            transform: 'translateY(-2px)'
        }
    };

    return (
        <AppBar
            position="fixed"
            sx={{
                backgroundColor: isScrolled ? "rgba(255, 255, 255, 0.95)" : "transparent",
                backdropFilter: isScrolled ? "blur(10px)" : "none",
                transition: "all 0.4s ease-in-out",
                boxShadow: isScrolled ? "0 4px 20px rgba(0,0,0,0.08)" : "none",
                paddingY: isScrolled ? '5px' : '15px'
            }}
        >
            <Grid
                container
                sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    padding: { md: '0px 40px', sm: '0px 40px', xs: '0px 30px' },
                }}
            >
                {/* Logo */}
                <Grid item xs={6} md={4} sx={{ textAlign: { xs: 'left', md: 'left' } }}>
                    {isScrolled ? (
                        <Box
                            component="img"
                            src={logo_black}
                            alt="Logo"
                            sx={{
                                width: { xs: '80%', md: '40%', sm: '70%' },
                                height: { xs: '80%', md: '40%', sm: '70%' },
                                cursor: 'pointer',
                                transition: 'transform 0.3s ease',
                                '&:hover': { transform: 'scale(1.05)' }
                            }} onClick={() => navigate('/')}
                        />
                    ) : (
                        <Box
                            component="img"
                            src={logo}
                            alt="Logo"
                            sx={{
                                width: { xs: '80%', md: '40%', sm: '70%' },
                                height: { xs: '80%', md: '40%', sm: '70%' },
                                cursor: 'pointer',
                                transition: 'transform 0.3s ease',
                                '&:hover': { transform: 'scale(1.05)' }
                            }} onClick={() => navigate('/')}
                        />
                    )}
                </Grid>


                {/* Desktop Navigation */}
                <Grid
                    item
                    xs={6}
                    md={8}
                    sx={{
                        display: { xs: 'none', md: 'flex' },
                        justifyContent: { xs: 'center', md: 'flex-end' },
                        gap: 5, // Reduced gap for a tighter modern look
                    }}
                >
                    <Button sx={{ ...buttonStyle, color: isScrolled ? '#1e293b' : '#fff' }} onClick={() => navigate('/')}>
                        Home
                    </Button>
                    <Button
                        sx={{ ...buttonStyle, color: isScrolled ? '#1e293b' : '#fff' }}
                        onClick={() => window.location.href = 'https://www.getmycollege.com/about-us'}
                    >
                        About
                    </Button>
                    <Button
                        sx={{ ...buttonStyle, color: isScrolled ? '#1e293b' : '#fff' }}
                        onClick={handlePopoverOpen}
                    >
                        Academics
                        {anchorEl ? <ArrowDropUp /> : <ArrowDropDown />}
                    </Button>
                    <Popover
                        open={Boolean(anchorEl)}
                        anchorEl={anchorEl}
                        onClose={handlePopoverClose}
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'left',
                        }}
                        transformOrigin={{
                            vertical: 'top',
                            horizontal: 'left',
                        }}
                        PaperProps={{
                            sx: {
                                borderRadius: '12px',
                                boxShadow: '0 10px 25px rgba(0,0,0,0.1)',
                                mt: 1
                            }
                        }}
                    >
                        <Box sx={{ display: 'flex', flexDirection: 'column', padding: 1 }}>
                            <Typography sx={{ p: 1.5, color: '#1e293b', fontSize: '1rem', cursor: 'pointer', borderRadius: '8px', '&:hover': { backgroundColor: '#f1f5f9', color: '#1a237e' } }} onClick={() => { handlePopoverClose(); navigate('/science-page'); }}>
                                Science Stream
                            </Typography>
                            <Typography sx={{ p: 1.5, color: '#1e293b', fontSize: '1rem', cursor: 'pointer', borderRadius: '8px', '&:hover': { backgroundColor: '#f1f5f9', color: '#1a237e' } }} onClick={() => { handlePopoverClose(); navigate('/commerce-page'); }}>
                                Commerce Stream
                            </Typography>
                            <Typography sx={{ p: 1.5, color: '#1e293b', fontSize: '1rem', cursor: 'pointer', borderRadius: '8px', '&:hover': { backgroundColor: '#f1f5f9', color: '#1a237e' } }} onClick={() => { handlePopoverClose(); navigate('/arts-page'); }}>
                                Arts Stream
                            </Typography>
                        </Box>
                    </Popover>
                    <Button sx={{ ...buttonStyle, color: isScrolled ? '#1e293b' : '#fff' }} onClick={() => navigate('/admission-page')}>
                        Admissions
                    </Button>
                    <Button sx={{
                        ...buttonStyle,
                        color: '#fff',
                        backgroundColor: '#ff5722',
                        padding: '8px 24px',
                        borderRadius: '25px',
                        boxShadow: '0 4px 14px rgba(255, 87, 34, 0.4)',
                        '&:hover': { backgroundColor: '#e64a19', transform: 'translateY(-2px)', color: '#fff', boxShadow: '0 6px 20px rgba(255, 87, 34, 0.6)' }
                    }} onClick={() => window.location.href = 'https://www.getmycollege.com/contact-us'}>
                        Contact
                    </Button>
                </Grid>

                {/* Mobile Drawer Toggle */}
                <Grid
                    item
                    xs={6}
                    md={false}
                    sx={{
                        display: { xs: 'flex', md: 'none' },
                        justifyContent: 'flex-end',
                    }}
                >
                    <IconButton onClick={toggleDrawer(true)} sx={{ color: isScrolled ? '#1e293b' : '#1e293b' }}>
                        <MenuIcon fontSize="large" />
                    </IconButton>
                </Grid>

                {/* Mobile Drawer */}
                <Drawer
                    anchor="right"
                    open={drawerOpen}
                    onClose={toggleDrawer(false)}
                    PaperProps={{
                        sx: {
                            backgroundColor: 'rgba(255, 255, 255, 0.95)',
                            backdropFilter: 'blur(10px)'
                        }
                    }}
                >
                    <Box
                        sx={{
                            width: 250,
                            padding: 2,
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'flex-start',  // Aligns content to the left
                        }}
                    >
                        <IconButton
                            onClick={(event) => {
                                event.preventDefault();
                                toggleCloser(false)(event);
                            }}
                            sx={{ color: '#1e293b', alignSelf: 'flex-end', mb: 2 }}
                        >
                            <CloseIcon />
                        </IconButton>

                        {[
                            { text: 'Home', icon: <HouseIcon sx={{ mr: 2 }} />, onClick: () => navigate('/') },
                            { text: 'About', icon: <InfoIcon sx={{ mr: 2 }} />, onClick: () => window.location.href = 'https://www.getmycollege.com/about-us' },
                            { text: 'Admissions', icon: <CastForEducationIcon sx={{ mr: 2 }} />, onClick: () => navigate('/admission-page') },
                            { text: 'Contact', icon: <LocalPhoneIcon sx={{ mr: 2 }} />, onClick: () => window.location.href = 'https://www.getmycollege.com/contact-us' },
                        ].map((item, index) => (
                            <Button
                                key={index}
                                sx={{ width: '100%', justifyContent: 'flex-start', color: '#1e293b', fontSize: '1.2rem', textTransform: 'none', py: 1.5, '&:hover': { backgroundColor: '#f1f5f9', color: '#1a237e' } }}
                                onClick={item.onClick}
                            >
                                {item.icon} {item.text}
                            </Button>
                        ))}

                        <Button
                            sx={{ width: '100%', justifyContent: 'flex-start', color: '#1e293b', fontSize: '1.2rem', textTransform: 'none', py: 1.5, '&:hover': { backgroundColor: '#f1f5f9', color: '#1a237e' } }}
                            onClick={handlePopoverOpen}
                        >
                            <SchoolIcon sx={{ mr: 2 }} /> Academics
                            {anchorEl ? <ArrowDropUp /> : <ArrowDropDown />}
                        </Button>

                        <Popover
                            open={Boolean(anchorEl)}
                            anchorEl={anchorEl}
                            onClose={handlePopoverClose}
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'left',
                            }}
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'left',
                            }}
                            PaperProps={{
                                sx: { width: 220, borderRadius: '12px' }
                            }}
                        >
                            <Box sx={{ display: 'flex', flexDirection: 'column', padding: 1 }}>
                                <Typography sx={{ p: 1.5, color: '#1e293b', fontSize: '1rem', cursor: 'pointer', borderRadius: '8px', '&:hover': { backgroundColor: '#f1f5f9', color: '#1a237e' } }} onClick={() => { handlePopoverClose(); toggleDrawer(false)(); navigate('/science-page') }}>
                                    Science Stream
                                </Typography>
                                <Typography sx={{ p: 1.5, color: '#1e293b', fontSize: '1rem', cursor: 'pointer', borderRadius: '8px', '&:hover': { backgroundColor: '#f1f5f9', color: '#1a237e' } }} onClick={() => { handlePopoverClose(); toggleDrawer(false)(); navigate('/commerce-page') }}>
                                    Commerce Stream
                                </Typography>
                                <Typography sx={{ p: 1.5, color: '#1e293b', fontSize: '1rem', cursor: 'pointer', borderRadius: '8px', '&:hover': { backgroundColor: '#f1f5f9', color: '#1a237e' } }} onClick={() => { handlePopoverClose(); toggleDrawer(false)(); navigate('/arts-page') }}>
                                    Arts Stream
                                </Typography>
                            </Box>
                        </Popover>
                    </Box>
                </Drawer>

            </Grid>
        </AppBar>
    );
};

export default Header1;
